import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import type { HttpErrorResponse } from '@/types/error'
import { ResetPassword2Page } from '@/pages/auth/login/ChangePasswordPage'
import { AuthChangePasswordSearchSchema } from '@/schemas/page'
import { authService } from '@/services'
import { isHttpError } from '@/utils/http'

export const Route = createFileRoute('/auth/change-password')({
  validateSearch: AuthChangePasswordSearchSchema,
  beforeLoad: async ({ search }) => {
    try {
      await authService.verifyResetPassword({
        token: search.reset_password_token,
      })
      return Promise.resolve({ success: true })
    } catch (error) {
      if (isHttpError(error)) {
        const resError = await error.response.json<HttpErrorResponse>()
        const message = 'error' in resError ? resError.error : resError.message
        return redirect({ replace: true, to: '/home', search: { message } })
      }
      throw notFound({
        throw: true,
      })
    }
  },
  component: ResetPassword2Page,
})
